import Pin from "../../../../systemDesign/Sep/Pin";
import LevrageSVG from "../../../../../svgs/LevrageSVG";
import AILawyerCard from "./Cards/AILawyerCard";
import GlobalArrowSVG from "../../../../../svgs/GlobalArrowSVG";
import SecuritySVG from "../../../../../svgs/SecuritySVG";
import UserSVG from "../../../../../svgs/UserSVG";
import EfficencyBanner from "../../../../../svgs/EfficencyBanner";

const AILawyer = () => {
  return (
    <div className="w-full flex flex-col justify-center items-center mt-4 lg:mt-6 border-y border-stroke1">
      <div className="w-full flex justify-between">
        <div className="w-1/2 lg:w-1/3">
          <h2 className="mt-8 mb-20 text-text3 text-[20px] md:text-[32px] px-5 h-10 lg:whitespace-nowrap">
            Who is AI Lawyer for?
          </h2>
          <AILawyerCard
            topic="Elastic scalability"
            title="Handle unbelievable scale without a sweat, whether you’re on Fortune
                   500, or it’s your launch day."
            icon={<LevrageSVG />}
          />
          <AILawyerCard
            topic="Global performance"
            title="Automatically route traffic
                   to over 100 edge locations
                   around the globe, for a fast
                   site, anywhere in the world."
            icon={<GlobalArrowSVG />}
          />
        </div>
        <div className="w-1/2 lg:w-1/3 border-l border-subColor4">
          <div className="w-full h-[80px] relative px-6 flex justify-center items-center mt-14 mb-[14px] border-y border-stroke1 lg:invisible">
            <EfficencyBanner width={200} />
            <Pin className="-left-[10.5px] -top-[10.5px]" />
          </div>
          <AILawyerCard
            topic="Rock-solid security"
            title="Infrastructure designed to
                   automatically mitigate
                   DDoS attacks and protect
                   your information."
            icon={<SecuritySVG />}
          />
          <AILawyerCard
            topic="User-first protection"
            title="Vercel automatically
                   caches your site to ensure
                   that even if a backend
                   service goes down, your site
                   stays up."
            icon={<UserSVG />}
          />
        </div>
        <div className="hidden w-1/3 lg:block border-l border-subColor4">
          <div className="w-full h-[120px] relative px-6 flex justify-center items-center mt-28 mb-[14px] border-y border-stroke1">
            <EfficencyBanner width={250} />
            <Pin className="-left-[10.5px] -top-[10.5px]" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AILawyer;
